// extracted by mini-css-extract-plugin
export default {"switcher":"ThemeSwitcher-module__switcher--YGJ1a","button":"ThemeSwitcher-module__button--wrKwf","active":"ThemeSwitcher-module__active--D08aq"};